"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncAppleChannelMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.SyncAppleChannelMessageSchema = (0, core_1.StrictObject)({
    campaign: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
        channel: (0, core_1.StrictObject)({
            id: core_1.IdSchema,
            structure: ruby_1.ChannelStructureSchema,
            // Limit to only this apple campaign reference
            campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
        }),
    }),
    mode: ruby_1.SyncModeSchema,
});
